export default "__VITE_ASSET__BK8u5WT$__"